import React from 'react';
import Icon from '../../../components/AppIcon';

const GenerationPanel = ({ content, isGenerating }) => {
  const sampleGenerations = [
    {
      id: 1,
      type: 'Executive Summary',
      content: 'Q4 2025 Safety Performance: Overall incident rate decreased by 18% compared to Q3, with significant improvements in behavioral safety compliance. Key achievements include zero LTI days for 45 consecutive days and 95% completion of mandatory safety training.',
      confidence: 0.92,
      source: 'Incident data (Oct-Dec 2025), Training records, Behavioral observations',
      timestamp: '2025-12-06 11:45',
    },
    {
      id: 2,
      type: 'Trend Analysis',
      content: 'Analysis of near-miss reports over the past 6 months reveals a positive trend in proactive safety culture. Employee reporting increased by 34%, with 67% of near-misses identified through behavioral safety observations. Primary hazard categories: Fall hazards (28%), Equipment-related (24%), Chemical exposure (18%).',
      confidence: 0.88,
      source: 'Near-miss database, HAZID records, Observation logs',
      timestamp: '2025-12-06 11:30',
    },
    {
      id: 3,
      type: 'Compliance Statement',
      content: 'The facility maintains full compliance with OSHA 1910 standards and ISO 45001:2018 requirements. Recent internal audit (Nov 2025) identified 3 minor non-conformities, all addressed within required timeframes. All statutory permits current and valid through 2026.',
      confidence: 0.95,
      source: 'Audit reports, Permit tracking, Compliance checklist',
      timestamp: '2025-12-06 11:15',
    },
    {
      id: 4,
      type: 'Recommendations',
      content: 'Based on incident trend analysis: 1) Implement additional fall protection training for contractors, 2) Enhance pre-job safety briefings for high-risk work, 3) Conduct quarterly safety culture surveys, 4) Install additional safety signage in warehouse areas, 5) Review and update emergency response procedures.',
      confidence: 0.90,
      source: 'Incident analysis, Safety committee feedback, Risk assessment',
      timestamp: '2025-12-06 11:00',
    },
  ];

  if (isGenerating) {
    return (
      <div className="bg-muted/30 rounded-lg p-8 flex flex-col items-center justify-center min-h-[400px]">
        <div className="w-16 h-16 border-4 border-primary border-t-transparent rounded-full animate-spin mb-4"></div>
        <p className="text-lg font-medium text-foreground mb-2">Generating AI Content...</p>
        <p className="text-sm text-muted-foreground">Analyzing data sources and creating narrative</p>
      </div>
    );
  }

  if (content) {
    return (
      <div className="bg-card border border-border rounded-lg p-6">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold text-foreground">Generated Content</h3>
          <div className="flex items-center gap-2">
            <button className="p-2 hover:bg-muted rounded-lg transition-colors">
              <Icon name="Copy" size={18} />
            </button>
            <button className="p-2 hover:bg-muted rounded-lg transition-colors">
              <Icon name="Download" size={18} />
            </button>
          </div>
        </div>
        <div className="prose max-w-none">
          <p className="text-foreground whitespace-pre-wrap">{content}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-foreground">Recent AI Generations</h3>
        <button className="text-sm text-primary hover:text-primary/80 transition-colors">
          View All
        </button>
      </div>

      {sampleGenerations?.map((item) => (
        <div key={item?.id} className="bg-card border border-border rounded-lg p-6 hover:shadow-md transition-shadow">
          <div className="flex items-start justify-between mb-3">
            <div className="flex items-center gap-2">
              <Icon name="FileText" size={18} color="var(--color-primary)" />
              <h4 className="font-semibold text-foreground">{item?.type}</h4>
            </div>
            <div className="flex items-center gap-2">
              <div className="flex items-center gap-1 px-2 py-1 bg-success/10 text-success rounded-lg text-xs font-medium">
                <Icon name="CheckCircle" size={14} />
                {Math.round(item?.confidence * 100)}% confidence
              </div>
              <button className="p-1 hover:bg-muted rounded transition-colors">
                <Icon name="MoreVertical" size={18} />
              </button>
            </div>
          </div>

          <p className="text-sm text-foreground mb-4 line-clamp-3">{item?.content}</p>

          <div className="flex items-center justify-between pt-3 border-t border-border">
            <div className="text-xs text-muted-foreground">
              <Icon name="Database" size={12} className="inline mr-1" />
              {item?.source}
            </div>
            <div className="flex items-center gap-3">
              <span className="text-xs text-muted-foreground">{item?.timestamp}</span>
              <button className="text-xs text-primary hover:text-primary/80 font-medium">
                Use This
              </button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default GenerationPanel;